var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-container"},[_c('el-pagination',{ref:"pagination",attrs:{"background":"","current-page":_vm.listQuery.page,"page-sizes":_vm.pageSizes,"page-size":_vm.listQuery.limit,"total":_vm.total,"layout":_vm.layout},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }